// Composant pour contenu statique SEO-friendly
export default function StaticContent() {
  return (
    <div className="sr-only" aria-hidden="true">
      {/* Contenu statique pour les moteurs de recherche */}
      <h1>SOSSOU Didi Orlog - Développeur FullStack et Data Scientist</h1>
      
      <h2>Expertise en Développement Web</h2>
      <p>
        Développeur FullStack spécialisé en React.js, Next.js, Node.js, Laravel et PHP. 
        Création d'applications web modernes avec architectures scalables et interfaces utilisateur responsives.
        Expert en APIs RESTful, bases de données et solutions cloud AWS.
      </p>
      
      <h2>Intelligence Artificielle et Machine Learning</h2>
      <p>
        Spécialiste en Intelligence Artificielle avec expertise en Machine Learning et Deep Learning. 
        Utilisation de Python, PyTorch, TensorFlow et Scikit-learn pour développer des modèles prédictifs avancés.
        Déploiement de solutions IA sur AWS SageMaker et Google Cloud Platform.
      </p>
      
      <h2>Science des Données et Analytics</h2>
      <p>
        Data Scientist expérimenté en analyse et visualisation de données avec Power BI, Python et XLSTAT.
        Expertise en collecte, nettoyage et transformation de données pour générer des insights métier exploitables.
        Développement de tableaux de bord interactifs et rapports analytiques.
      </p>
      
      <h2>Compétences Techniques</h2>
      <ul>
        <li>Langages: JavaScript, TypeScript, Python, PHP, SQL</li>
        <li>Frontend: React.js, Next.js, Vue.js, HTML5, CSS3, Tailwind CSS</li>
        <li>Backend: Node.js, Laravel, Express.js, FastAPI, Django</li>
        <li>Bases de données: MySQL, PostgreSQL, MongoDB, Redis</li>
        <li>Cloud: AWS, Google Cloud, Heroku, Vercel</li>
        <li>IA/ML: PyTorch, TensorFlow, Scikit-learn, Pandas, NumPy</li>
        <li>Outils: Git, Docker, Webpack, Jenkins, Power BI</li>
      </ul>
      
      <h2>Formation et Certifications</h2>
      <p>
        Master 1 en Intelligence Artificielle et Big Data (École Polytechnique de Lomé & UTBM).
        Certifications DataCamp Data Scientist et Data Engineer 2025.
        Nanodegree Machine Learning Fundamentals Udacity 2024.
        Formation Applied Data Science Lab WorldQuant University.
      </p>
      
      <h2>Expérience Professionnelle</h2>
      <p>
        Ingénieur Logiciel FullStack chez Bidiffy (BIDIF SARL) - Développement principal backend et frontend 
        sur la plateforme SaaS draavis.com de location de véhicules.
        Consultant Ingénieur logiciel à l'Ambassade d'Angola au Togo.
        Développeur au Port Autonome de Lomé - Système de gestion des véhicules.
        Développeur Web bénévole chez ENT-Togo.
      </p>
      
      <h2>Projets et Réalisations</h2>
      <p>
        Développement de solutions web complexes incluant plateformes de location, 
        systèmes de gestion, applications de tontines en ligne.
        Participation au Challenge IA MENTD/ATD/Zindi - 6ème place en prédiction adoption fibre optique.
        Lauréat bourse d'excellence académique Fondation Nana Anè XV.
      </p>
      
      <h2>Services Proposés</h2>
      <p>
        Développement d'applications web sur mesure, solutions IA personnalisées,
        analyse de données et business intelligence, formation en technologies web et IA,
        conseil en transformation digitale et architectures techniques.
      </p>
      
      <h2>Contact</h2>
      <p>
        Disponible pour projets freelance et collaborations.
        Basé à Lomé, Togo. Travail à distance possible.
        Contact: contact@orlogsd.dev
        Portfolio: https://www.orlogsd.dev
      </p>
    </div>
  )
}
